module.exports = "4e66da42e2717e03cabcfdba7381511b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/bg6.png
// module id = 76
// module chunks = 0